import { useCallback, useEffect, useMemo, useState } from 'react';
import { OptionType } from '@ru-digital-assets/ui-component/dist/stories/ui/ui-select/ui-select';
import { useDispatch } from 'hooks';
import { useCryptoCertificates } from 'hooks/useCryptoCertificates';
import { setPush } from 'store/actions/app';
import { checkUserSystem } from 'utils/cryptoPro/checkUtils';

export const useSign = (isActive: boolean = true) => {
  const [isSystemError, setIsSystemError] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState<OptionType>();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isActive) {
      checkUserSystem().then((res) => setIsSystemError(!res));
    }
  }, [isActive]);

  const onCryptoProError = useCallback((message: string) => {
    dispatch(
      setPush({
        type: 'error',
        message,
      })
    );
  }, []);

  const { certificates, signEntity } = useCryptoCertificates(
    selectedCertificate?.value,
    onCryptoProError,
    isActive
  );

  const onUserSelectCertificate = useCallback(
    (certificate: OptionType | OptionType[] | undefined) => {
      if (certificate) {
        setSelectedCertificate(certificate as OptionType);
      }
    },
    []
  );

  const certificatesList = useMemo(
    () =>
      certificates.map((item) => ({
        value: item.thumbprint,
        label: `${item.name} ( от ${item.validFrom.substr(0, 10)} )`,
      })),
    [certificates]
  );

  return {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
    isSystemError,
    usersCertificates: certificates,
  };
};
